(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .factory('GroupPractice', GroupPracticeFactoryFn);

    GroupPracticeFactoryFn.$inject = ['Item'];

    function GroupPracticeFactoryFn(Item) {

        var GroupPractice = function () {

            // default values
            this.caption = null;
            this.deleted = false;
            this.sortOrder = 0;

            // extend object
            function extend(category) {
                var self = this;
                angular.extend(self, category);
            } // extend

                  //public
            this.extend = extend;
        };

        // extend
        GroupPractice.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        }

        return GroupPractice;
    }
})();